import React, { useEffect, useMemo, useRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { CircularProgress, Backdrop, IconButton } from '@mui/material';
import "./talkToAI.scss"
import moment from 'moment';
import { makeStyles, styled } from '@mui/styles';
import { getAIChatHistoryOfIssue, getCategories, sentMessageToAI } from '../../services/talkToAI.service';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import { AI_CHAT_PLATFORMS, CHATBOT_URL } from '../../services/const';
import { Button } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles({
  talkToAIDialogContent: {
    margin: 0,
    padding: 0,
  },
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
      padding: '16px',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'flex-direction': 'column',

  },
  '& .MuiPaper-root': {
      'max-width': 'initial',
      padding: '20px'
  },
  '& .MuiDialogActions-root': {
      padding: '8px',
  },
}));

const TYPE_AI_RESPONSE = "AI_RESPONSE"
const formateChatMessage = (messages:any[]) :AIChatMessage[] =>{
  if(Array.isArray(messages) && messages.length){
    return messages.sort((a,b):any =>{
      const dataA = new Date(a.createdAt);
      const dataB = new Date(b.createdAt);
      return dataA.getTime() - dataB.getTime();
    }).map(mess => {  
        return {   
          type: mess?.sender === TYPE_AI_RESPONSE ? 'visitor'  : mess?.sender ,
          message:mess?.message,
          time: moment(mess?.createdAt).format('dddd, MMM D, YYYY, h:mm A'),
          imageUrls:[]
        }
    });
  }else {
    return [];
  }
}


const  ExpertModalContainer =({onClose}:{onClose: () => void;}) =>{
  return (
    <>
      <div className="expert-modal-container">
          <div className="expert-modal-section">
              <div className="expert-card-header">
                
                  {/* for reference
                   <span  className="expert-modal-back" onClick="backExpertModal()" >
                      <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill="#000000" d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"></path><path fill="#000000" d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"></path></g></svg>
                  </span> */}
                  <span className="expert-modal-back" >
                    Talk To AI
                  </span>
                  <span className="expert-modal-close" onClick={onClose}>
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="Menu / Close_LG"> <path id="Vector" d="M21 21L12 12M12 12L3 3M12 12L21.0001 3M12 12L3 21.0001" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g> </g></svg>
                  </span>
              </div>
              <div className="expert-card-body">
              </div>
              {/* <div id="expert-chatbotai" className="button-section-video" style="display: none; min-height: 405px; overflow: auto;">${ (aiFeatures && aiFeatures.length && aiFeatures.length != 1 && aiFeatures.includes("chatbotai")) ? aiChatBotContainer(false) : ""}</div> */}
              <div id="expert-chatbotai" className="button-section-video" style={{ minHeight: "405px", overflow: "auto"}} >
                <AiChatBotContainer />
              </div>
          </div>
      </div>
    </>
  )
}

const AiChatBotContainer = () => {
  const [chatMessages, setChatMessage] = useState<AIChatMessage[]>([]);
  const [message,setMessage] = useState("");
  const [waitingChatResponse, setWaitingChatResponse] = useState<boolean>(false);
  const [chatHistoryLoading, setChathistoryLoading] = useState<boolean>(false);
  const [categoriesLoading, setCategoriesLoading] = useState<boolean>(false);
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const issueDetails = useSelector((state: RootState) => state.issue);
  const projectState = useSelector((state: RootState) => state.project);
  const userState = useSelector((state: RootState) => state.user);
  const userDetails = userState.user?.userDetails
  const [selectedCategory, setSelectedCategory] = useState<string>()
  const [categories, setCategories] = useState<any[]>([])

  const projectTypeMenu = projectState.projectTypeMenu
  const projectType = projectState.projectType

  const loadingChatMessage = {imageUrls:[],message:"Typing ...",time: moment().format('dddd, MMM D, YYYY, h:mm A'), type:"visitor"};

  const currentPlatform =  useMemo(()=> {
    switch(projectType){
      case(projectTypeMenu[0]): {
        return AI_CHAT_PLATFORMS[0];
      }
      case(projectTypeMenu[1]): {
        return AI_CHAT_PLATFORMS[1];
      }
      case(projectTypeMenu[2]): {
        return AI_CHAT_PLATFORMS[2];
      }
      default:
        return projectType
    }
  },[projectType])

  const getChatCategories = async() => {
    try {
      setCategoriesLoading(true)
      const response = await getCategories(currentPlatform) ;
      if(response.statusCode === 200) {
        setCategories(response?.data);
      }
    } catch (error) {
      // handle while api integration
    }
    setCategoriesLoading(false)
  }


  const getAIChatList = async() => {
    setChathistoryLoading(true);
    try {
      const response = await  getAIChatHistoryOfIssue({issueKey:issueDetails?.key}) ;
      if(response.statusCode === 200) {
        setChatMessage(formateChatMessage(response?.data));
      }
    } catch (error) {
      // handle while api integration
    }
    setChathistoryLoading(false);
  }

  const sendMessage = async() => {
    try {
      const currentTime = moment().format('dddd, MMM D, YYYY, h:mm A');
      setChatMessage([...chatMessages,{imageUrls:[],message,time: currentTime, type:""}]);
      setMessage("");

      setWaitingChatResponse(true);
      const response = await sentMessageToAI({issueKey:issueDetails?.key,message,platform:currentPlatform,userName:userDetails?.name!});
      if(response?.statusCode === 200) {
        const temResponseData = { imageUrls:[], message: `test response - ${message}`, time: currentTime, type:'visitor'}
        setChatMessage((chatMessages) => ([...chatMessages,temResponseData]));
      }
    } catch (error) {
      // handle while api integration
      
    }
    setWaitingChatResponse(false);

  }

  const handleSelectedCategory = (category:any) => {
    if( category?.id === selectedCategory ){
      setSelectedCategory("");
    }else {
      setSelectedCategory(category?.id)
    }
  }

  const handleMessageChange = (event:any) => {
    if(event?.target?.value){
      setMessage(event?.target?.value);
    }
  }
  const handleEnterKey = (event:any) =>{
    if(event.key === "Enter" && message.length){
      return sendMessage();
    }
  }

  const scrollToButtom = () =>{
    messagesEndRef?.current?.scrollIntoView({behavior: "smooth"});
  }

  useEffect(()=>{
    getAIChatList();
    getChatCategories();
  },[])

  useEffect(()=>{
    scrollToButtom();
  },[chatMessages?.length])

  return (
  <div className="floating-chat-ai">
    <div className="chat-ai" id="chat-ai" >
      <div className="header-ai">
          <div className="head">
              <div className="flex">
              <svg width="40" height="40" viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.02126 31.3086C9.02126 31.3086 8.56848 31.7945 8.77439 32.5607C8.9803 33.3268 11.9438 39.8093 15.2048 39.9936C18.4658 40.1779 21.3618 35.1063 21.9921 33.2639C22.6223 31.4215 21.998 31.35 21.998 31.35L9.02126 31.309V31.3086Z" fill="#908BA3"/>
                  <path d="M7.91712 28.9057L8.93708 31.9443C9.01309 32.1708 9.17361 32.3588 9.38469 32.4695C10.0736 32.8299 11.7512 33.6031 13.6627 33.7193C13.7449 33.7245 13.818 33.773 13.8545 33.847C13.9951 34.1298 14.4143 34.8145 15.1845 34.8444C15.9387 34.8737 16.297 34.3985 16.4524 34.0868C16.5181 33.9547 16.6454 33.8644 16.7915 33.8477C17.5886 33.7563 20.0931 33.4151 21.5219 32.6142C21.7086 32.5094 21.8525 32.3429 21.9304 32.1434L23.2529 28.7454L10.8017 27.0703L7.91602 28.9057H7.91712Z" fill="#C1DBFF"/>
                  <path d="M26.9459 20.0149C26.9535 17.5837 25.6431 15.6087 24.019 15.6036C22.3949 15.5985 21.0722 17.5652 21.0646 19.9964C21.057 22.4276 22.3674 24.4026 23.9914 24.4077C25.6155 24.4128 26.9383 22.4461 26.9459 20.0149Z" fill="#C1DBFF"/>
                  <path d="M10.0845 19.8821C10.0922 17.4509 8.78176 15.4759 7.15768 15.4708C5.5336 15.4657 4.21086 17.4324 4.20324 19.8636C4.19563 22.2948 5.50603 24.2698 7.1301 24.2749C8.75418 24.28 10.0769 22.3133 10.0845 19.8821Z" fill="#C1DBFF"/>
                  <path d="M11.1116 7.72421C11.118 5.68691 9.80659 4.0312 8.18251 4.02609C6.55843 4.02097 5.23669 5.66838 5.2303 7.70568C5.22392 9.74297 6.53532 11.3987 8.1594 11.4038C9.78348 11.4089 11.1052 9.76151 11.1116 7.72421Z" fill="#C1DBFF"/>
                  <path d="M9.90029 13.5604C9.90029 13.5604 6.04964 14.4723 5.79834 18.8578C5.58579 22.5614 7.04598 27.5283 7.50503 28.9825C7.59138 29.256 7.79507 29.4762 8.06039 29.5835C8.82499 29.8929 10.5951 30.494 13.0542 30.6224C13.2937 30.635 13.5089 30.4751 13.565 30.2412C13.6937 29.7038 14.1048 28.8085 15.4108 28.7578C15.4108 28.7578 16.9411 28.8433 17.3211 30.2427C17.3835 30.4721 17.5975 30.6269 17.8341 30.6113C18.7747 30.5499 21.0552 30.3241 23.0966 29.5165C23.3707 29.4081 23.5789 29.1775 23.6619 28.8936C24.0697 27.495 25.3025 23.0629 25.5114 19.934C25.762 16.1752 22.8777 13.8143 21.281 13.5389C19.6843 13.2636 9.90029 13.5604 9.90029 13.5604Z" fill="#908BA3"/>
                  <path d="M8.77735 14.0207C8.69285 14.0707 11.3405 16.9186 15.7462 16.9327C20.1522 16.9468 22.5541 14.0636 22.5541 14.0636L19.1942 12.5547L9.90137 13.5603C9.90137 13.5603 9.17183 13.7875 8.77735 14.0207Z" fill="#C1DBFF"/>
                  <path d="M26.1624 7.77108C26.1688 5.73378 24.8574 4.07808 23.2333 4.07296C21.6092 4.06784 20.2875 5.71525 20.2811 7.75255C20.2747 9.78985 21.5861 11.4456 23.2102 11.4507C24.8343 11.4558 26.156 9.80838 26.1624 7.77108Z" fill="#C1DBFF"/>
                  <path d="M25.5602 7.99774C25.5739 3.6151 21.1726 0.048374 15.7295 0.0312233C10.2864 0.0140725 5.8628 3.553 5.84908 7.93563C5.83535 12.3183 10.2367 15.885 15.6798 15.9021C21.1228 15.9193 25.5465 12.3804 25.5602 7.99774Z" fill="#908BA3"/>
                  <path d="M16.3406 31.9953C16.344 30.8997 15.8885 30.0101 15.3232 30.0083C14.7578 30.0066 14.2968 30.8933 14.2933 31.9889C14.2899 33.0845 14.7454 33.9741 15.3107 33.9759C15.8761 33.9777 16.3372 33.0909 16.3406 31.9953Z" fill="#14274E"/>
                  <path d="M11.7988 3.70614L19.6414 3.73085C21.5374 3.73682 23.072 5.28576 23.0661 7.18737L23.0615 8.64929C23.0555 10.5509 21.5112 12.0901 19.6152 12.0842L11.7726 12.0595C9.87663 12.0535 8.34195 10.5045 8.34791 8.60293L8.35249 7.14101C8.35844 5.2394 9.9028 3.70016 11.7988 3.70614Z" fill="#14274E"/>
                  <path d="M18.6013 25.0552C20.2944 23.3571 20.2944 20.6039 18.6013 18.9057C16.9081 17.2076 14.1631 17.2076 12.47 18.9057C10.7768 20.6039 10.7768 23.3571 12.47 25.0552C14.1631 26.7534 16.9081 26.7534 18.6013 25.0552Z" fill="#14274E"/>
                  <path d="M18.5359 24.3497C19.8435 22.6879 19.5603 20.2775 17.9034 18.966C16.2465 17.6545 13.8432 17.9385 12.5356 19.6003C11.228 21.2622 11.5112 23.6726 13.1681 24.9841C14.825 26.2956 17.2282 26.0115 18.5359 24.3497Z" fill="#C1DBFF"/>
                  <path d="M15.5284 24.9642C17.1727 24.9642 18.5083 23.6282 18.5114 21.9802C18.5146 20.3321 17.1841 18.9961 15.5398 18.9961C13.8955 18.9961 12.5599 20.3321 12.5568 21.9802C12.5536 23.6282 13.8841 24.9642 15.5284 24.9642Z" fill="#14274E"/>
                  <path d="M2.68006 21.2232C2.68006 21.2232 3.78341 19.0622 5.17016 18.6055L5.17422 19.9105C5.17422 19.9105 3.82474 21.0363 3.48081 22.1037L2.6819 21.8846L2.67969 21.2236L2.68006 21.2232Z" fill="#C1DBFF"/>
                  <path d="M1.53222 24.5863C1.53222 24.5863 1.51045 25.7644 1.53074 26.3625C1.53406 26.4576 1.48166 26.546 1.39642 26.5886C1.00379 26.7836 -0.0641315 27.4336 0.00302891 28.7101L0.0425133 29.5136C0.0572738 29.8134 0.304513 30.0487 0.603782 30.0476C0.913015 30.0465 1.16321 29.7945 1.1621 29.484L1.15988 28.7682C1.15988 28.7682 1.18719 27.6234 2.14294 27.4968C3.09868 27.3703 3.39426 28.1579 3.48762 28.498C3.50718 28.569 3.52563 28.6445 3.54223 28.7189C3.61124 29.028 3.90534 29.2319 4.21753 29.1857C4.56661 29.1338 4.79762 28.7933 4.71496 28.4491C4.54189 27.7296 4.07693 26.6456 2.83816 26.4639C2.72413 26.4472 2.63926 26.3499 2.63889 26.2344L2.6352 25.0819L1.53222 24.5859V24.5863Z" fill="#C1DBFF"/>
                  <path d="M28.6391 20.7858C28.6391 20.7858 27.5221 18.6318 26.1328 18.1836L26.1369 19.4886C26.1369 19.4886 27.4937 20.606 27.8439 21.6708L28.6414 21.4468L28.6391 20.7855V20.7858Z" fill="#C1DBFF"/>
                  <path d="M29.8087 24.1445C29.8087 24.1445 29.8379 25.3222 29.8213 25.9207C29.8187 26.0158 29.8718 26.1043 29.9571 26.1457C30.3508 26.3382 31.4228 26.9814 31.3637 28.2583L31.3294 29.0622C31.3165 29.362 31.0707 29.5988 30.7715 29.5999C30.4622 29.601 30.2106 29.3501 30.2095 29.04L30.2072 28.3242C30.2072 28.3242 30.1729 27.1798 29.2165 27.0591C28.26 26.9385 27.9696 27.7283 27.878 28.0688C27.8589 28.1402 27.8411 28.2157 27.8249 28.2901C27.7577 28.5995 27.4651 28.8053 27.1526 28.7613C26.8031 28.7117 26.5703 28.3727 26.6507 28.0281C26.8193 27.3079 27.2773 26.2205 28.515 26.031C28.629 26.0136 28.7135 25.9159 28.7131 25.8004L28.7094 24.6479L29.8091 24.1449L29.8087 24.1445Z" fill="#C1DBFF"/>
                  <path d="M16.9891 9.35041C15.9779 9.61418 15.0851 9.49346 14.5142 9.3459C14.3877 9.31325 14.2441 9.32613 14.1397 9.38005C14.035 9.43396 13.9935 9.51666 14.0313 9.5955C14.3648 10.29 15.1484 10.4371 15.7473 10.4384C15.7495 10.4384 15.752 10.4384 15.7542 10.4384C16.3524 10.4384 17.1335 10.2925 17.4727 9.60108C17.5117 9.52182 17.4702 9.4389 17.3651 9.38456C17.2604 9.33043 17.1164 9.31754 16.9895 9.35062L16.9891 9.35041Z" fill="white"/>
                  <path d="M1.07112 24.5416C1.09953 23.8598 1.2143 22.3838 1.67335 21.2028C1.81763 20.832 2.28333 20.7132 2.58924 20.9667L3.9782 22.1177C4.19039 22.2935 4.25127 22.5937 4.12507 22.8387C3.87599 23.3228 3.48336 24.1711 3.28298 25.0464C3.21103 25.3599 2.88334 25.5412 2.57964 25.4372L1.40913 25.0371C1.19917 24.9653 1.06152 24.7636 1.07075 24.5412L1.07112 24.5416Z" fill="#908BA3"/>
                  <path d="M30.2664 24.0927C30.2335 23.4114 30.1099 21.9361 29.6431 20.7581C29.4966 20.388 29.0302 20.2721 28.7257 20.5279L27.3441 21.6874C27.1331 21.8643 27.074 22.1648 27.2017 22.4095C27.4537 22.8921 27.8515 23.7378 28.0574 24.6116C28.1312 24.9247 28.4604 25.1039 28.7634 24.998L29.9313 24.5905C30.1409 24.5176 30.2771 24.3148 30.2664 24.0927Z" fill="#908BA3"/>
                  <path d="M14.005 20.8249C13.9467 20.7183 13.8137 20.6798 13.7074 20.7382C13.6011 20.7967 13.5627 20.9301 13.621 21.0367L14.2347 22.1579C14.2745 22.2308 14.3499 22.272 14.4267 22.272C14.4624 22.272 14.4987 22.2631 14.5324 22.2445C14.6386 22.1861 14.6771 22.0526 14.6188 21.946L14.005 20.8249Z" fill="white"/>
                  <path d="M17.2864 22.4442L16.3222 20.8175C16.2975 20.7756 16.2604 20.7446 16.2186 20.7274C16.2124 20.7247 16.2063 20.7226 16.2001 20.7206C16.1987 20.7206 16.1974 20.7199 16.196 20.7192C16.1912 20.7178 16.1857 20.7164 16.1809 20.7151C16.1782 20.7151 16.1761 20.7144 16.1734 20.7137C16.1692 20.713 16.1651 20.7123 16.161 20.7116C16.1576 20.7116 16.1548 20.7109 16.1514 20.7109C16.148 20.7109 16.1445 20.7109 16.1411 20.7109C16.1377 20.7109 16.1336 20.7109 16.1301 20.7109C16.1274 20.7109 16.124 20.7109 16.1212 20.7109C16.1171 20.7109 16.113 20.7109 16.1089 20.7123C16.1061 20.7123 16.1041 20.7123 16.1013 20.7137C16.0965 20.7144 16.0917 20.7151 16.0869 20.7164C16.0849 20.7164 16.0835 20.7171 16.0815 20.7178C16.076 20.7192 16.0705 20.7206 16.065 20.7226C16.0643 20.7226 16.0636 20.7226 16.0623 20.7233C16.0129 20.7405 15.9697 20.7756 15.9422 20.8251L15.5205 21.5955L15.0987 20.8251C15.0404 20.7185 14.9074 20.68 14.8011 20.7385C14.6948 20.7969 14.6564 20.9304 14.7147 21.037L15.2702 22.0522L14.7147 23.0674C14.6564 23.174 14.6955 23.3074 14.8011 23.3659C14.8347 23.3845 14.8711 23.3934 14.9067 23.3934C14.9842 23.3934 15.059 23.3521 15.0987 23.2792L15.5205 22.5089L15.9422 23.2792C15.982 23.3521 16.0575 23.3934 16.1343 23.3934C16.1699 23.3934 16.2063 23.3845 16.2399 23.3659C16.3462 23.3074 16.3846 23.174 16.3263 23.0674L15.7708 22.0522L16.1425 21.3733L16.9112 22.6698C16.9524 22.7393 17.0251 22.7771 17.0998 22.7771C17.1382 22.7771 17.1766 22.7675 17.2116 22.7462C17.3159 22.6843 17.3501 22.5495 17.2877 22.4449L17.2864 22.4442Z" fill="white"/>
                  <path d="M17.5019 23.3466C17.6199 23.3187 17.6929 23.2002 17.6651 23.0818C17.6372 22.9635 17.519 22.8903 17.4011 22.9182C17.2831 22.9461 17.2101 23.0647 17.2379 23.183C17.2657 23.3013 17.3839 23.3745 17.5019 23.3466Z" fill="white"/>
                  <ellipse cx="11.9344" cy="7.66288" rx="0.971471" ry="0.971473" fill="white"/>
                  <ellipse cx="19.4285" cy="7.66288" rx="0.971471" ry="0.971473" fill="white"/>
              </svg>
              <div className="head-icon28">waymore.io Chatbot</div>
              {/* <div className="chatbot-close" >
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_499_23695)">
                          <path d="M8.19188 7.41607C8.39717 7.21078 8.80775 7.21078 9.01304 7.41607L12.3661 10.7691L15.7191 7.41607C15.9244 7.21078 16.335 7.21078 16.5403 7.41607L16.9509 7.82664C17.1904 8.06615 17.1562 8.44251 16.9509 8.6478L13.5978 12.0009L16.9509 15.3539C17.1904 15.5934 17.1562 15.9698 16.9509 16.1751L16.5403 16.5856C16.3008 16.8251 15.9586 16.8251 15.7191 16.5856L12.3661 13.2326L9.01304 16.5856C8.77353 16.8251 8.43138 16.8251 8.19188 16.5856L7.7813 16.1751C7.57601 15.9698 7.5418 15.5934 7.7813 15.3539L11.1344 12.0009L7.7813 8.6478C7.57601 8.44251 7.5418 8.06615 7.7813 7.82665L8.19188 7.41607ZM3.88081 3.51558C8.56824 -1.17186 16.1639 -1.17186 20.8514 3.51557C25.5388 8.20301 25.5388 15.7987 20.8514 20.4861C16.1639 25.1736 8.56824 25.1736 3.88081 20.4861C-0.806623 15.7987 -0.806624 8.20301 3.88081 3.51558ZM4.97568 4.61045C0.904118 8.68202 0.904119 15.3197 4.97569 19.3913C9.04725 23.4628 15.6507 23.497 19.7565 19.3913C23.7938 15.3539 23.8623 8.71623 19.7565 4.61045C15.7191 0.573098 9.04725 0.538884 4.97568 4.61045Z" fill="white"/>
                      </g>
                      <defs>
                          <clipPath id="clip0_499_23695">
                              <rect width="24" height="24" fill="white" transform="translate(0.365234)"/>
                          </clipPath>
                      </defs>
                  </svg>
              </div> */}
              </div>
          </div>                 
      </div>

      <div className="messages-ai">
          <div className="message-section" id="chats-aii">

              {chatHistoryLoading && (
                <div className='chat-history-message-container' >
                  <div className='chat-history-message'>
                      <span>Getting chat history</span>
                      <div className="dot-falling"></div>
                  </div>
                </div>
              )
                
              }
              {chatMessages?.length ? chatMessages.map(
              (chatMessage,index) => 
                <AIChatMessage key={index} imageUrls={chatMessage.imageUrls} 
                  message={chatMessage.message} 
                  time={chatMessage.time} 
                  type={chatMessage.type} 
                />
              ) : ""}
              {waitingChatResponse && <AIChatMessage key={"waitingChatResponse"} imageUrls={loadingChatMessage.imageUrls} 
                  message={"Typing ..."} 
                  time={loadingChatMessage.time} 
                  type={loadingChatMessage.type} 
                />}

              <div ref={messagesEndRef}></div>
          </div>
      </div>

      <div className="footer-ai">
          <div className="footer-section">
              <div className="foot-width">
                  <div className="foot-text">
                    <div className='categories-container'>
                        {categories?.length ? 
                          categories.map(category => (
                            <Tooltip placement="top" title={category?.description || "description"}>
                              <Button className='categories-item' 
                                onClick={e=>handleSelectedCategory(category)}
                                variant={ selectedCategory === category?.id ?  "contained" : "outlined" }
                                >{category?.categoryName}</Button>
                            </Tooltip>
                          ))
                           : ""
                        }
                    </div>
                      <div className="text">Type or push the microphone to record your message.</div>
                      <div className="input-message">
                          <input value={message} onKeyDown={handleEnterKey} onChange={handleMessageChange} placeholder="Write your question here" id="AI-text" />
                          <div className="send-section">
                              <div className="send-icon">
                                  <div id="sendMessage" onClick={sendMessage} >
                                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <circle cx="12" cy="12" r="12" fill="#65A0BA"/>
                                          <mask id="mask0_2535_35336" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="4" y="4" width="16" height="16">
                                              <rect x="4" y="4" width="16" height="16" fill="#C4C4C4"/>
                                          </mask>
                                          <g mask="url(#mask0_2535_35336)">
                                              <path d="M6.93333 16.9509C6.71111 17.0397 6.5 17.0202 6.3 16.8922C6.1 16.7646 6 16.5786 6 16.3342V13.8509C6 13.6953 6.04444 13.5564 6.13333 13.4342C6.22222 13.312 6.34444 13.2342 6.5 13.2009L11.3333 12.0009L6.5 10.8009C6.34444 10.7675 6.22222 10.6897 6.13333 10.5675C6.04444 10.4453 6 10.3064 6 10.1509V7.66752C6 7.42307 6.1 7.23685 6.3 7.10885C6.5 6.9813 6.71111 6.96196 6.93333 7.05085L17.2 11.3842C17.4778 11.5064 17.6167 11.712 17.6167 12.0009C17.6167 12.2897 17.4778 12.4953 17.2 12.6175L6.93333 16.9509Z" fill="white"/>
                                          </g>
                                      </svg>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style={{"width": "250px"}}><span className="footer-powered">Powered by </span><span className="footer-waymore">WayMore</span></div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
  )
}

interface AIChatMessage {
  type:string,
  message:string,
  time:string,
  imageUrls:string[]
}

const AIChatMessage = ({type, message, time, imageUrls}:AIChatMessage) =>{
  return (
    <>
      {type === 'visitor' ? 
      <div className="ai-section">
          <div className="ai-width">
              <div className="ai-left">
                  <div className="ai-left-icon1">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="16" cy="16" r="16" fill="#14274E"/>
                          <path d="M21.1781 15.1915C21.1712 13.0217 22.5809 11.2583 24.3266 11.2528C26.0724 11.2474 27.4931 13.002 27.5 15.1718C27.5068 17.3416 26.0972 19.1051 24.3515 19.1105C22.6057 19.116 21.185 17.3614 21.1781 15.1915Z" fill="#14274E"/>
                          <path d="M23.6863 21.8985C23.7772 21.9517 20.9311 24.985 16.1955 24.9999C11.4594 25.0149 8.87756 21.9442 8.87756 21.9442L12.4891 20.3371L22.4781 21.4081C22.4781 21.4081 23.2623 21.6501 23.6863 21.8985Z" fill="#14274E"/>
                          <path d="M5.00002 15.2422C4.99316 13.0724 6.40281 11.309 8.14854 11.3035C9.89428 11.2981 11.315 13.0527 11.3219 15.2225C11.3288 17.3923 9.91912 19.1558 8.17338 19.1612C6.42765 19.1667 5.00688 17.4121 5.00002 15.2422Z" fill="#14274E"/>
                          <path d="M5.64621 15.4849C5.63146 10.8171 10.3625 7.01833 16.2133 7.00007C22.0642 6.9818 26.8191 10.751 26.8339 15.4187C26.8487 20.0865 22.1176 23.8852 16.2668 23.9035C10.416 23.9218 5.66097 20.1526 5.64621 15.4849Z" fill="#D6E2E7"/>
                          <path d="M20.4407 10.9158L12.0106 10.9421C9.97257 10.9484 8.32293 12.5981 8.32933 14.6235L8.33425 16.1805C8.34065 18.2058 10.0007 19.8452 12.0387 19.8388L20.4688 19.8125C22.5068 19.8061 24.1565 18.1564 24.15 16.1311L24.1451 14.5741C24.1387 12.5488 22.4787 10.9094 20.4407 10.9158Z" fill="#14274E"/>
                          <path d="M14.8237 16.9701C15.9218 17.2243 16.8913 17.108 17.5112 16.9658C17.6486 16.9343 17.8046 16.9468 17.9179 16.9987C18.0317 17.0507 18.0767 17.1303 18.0356 17.2063C17.6735 17.8754 16.8226 18.0172 16.1722 18.0184C16.1698 18.0184 16.1671 18.0184 16.1647 18.0184C15.5151 18.0184 14.6669 17.8779 14.2985 17.2117C14.2563 17.1353 14.3013 17.0554 14.4154 17.003C14.5291 16.9509 14.6855 16.9385 14.8233 16.9703L14.8237 16.9701Z" fill="white"/>
                          <path d="M19.2347 14.7022C19.2347 15.2339 19.6684 15.6649 20.2035 15.6649C20.7386 15.6649 21.1723 15.2339 21.1723 14.7022C21.1723 14.1704 20.7386 13.7394 20.2035 13.7394C19.6684 13.7394 19.2347 14.1704 19.2347 14.7022Z" fill="white"/>
                          <path d="M11.2688 14.7022C11.2688 15.2339 11.7025 15.6649 12.2376 15.6649C12.7727 15.6649 13.2064 15.2339 13.2064 14.7022C13.2064 14.1704 12.7727 13.7394 12.2376 13.7394C11.7025 13.7394 11.2688 14.1704 11.2688 14.7022Z" fill="white"/>
                      </svg>
                  </div>
              </div>
              <div className="ai-right">
                  <div className="ai-right-icon">{message}</div>
                  {imageUrls?.length ? imageUrls.map((imageUrl,index) => (
                    <img key={index} src={imageUrl} width="150" height="100"></img>
                  )) : "" }
              </div>
          </div>
          <div className="ai-message-time">{time}</div>
      </div>
      : 
      <div className="visitor-section">
          <div className="visitor-width">
              <div className="visitor-left">
                  <div className="visitor-left-icon">{message}</div>
              </div>
              <div className="visitor-right">
                  <div className="visitor-right-icon1">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="16" cy="16" r="16" fill="#4A4B4D"/>
                          <path d="M16 11.0968C17.7097 11.0968 19.0968 12.4839 19.0968 14.1935C19.0968 15.9032 17.7097 17.2903 16 17.2903C14.2903 17.2903 12.9032 15.9032 12.9032 14.1935C12.9032 12.4839 14.2903 11.0968 16 11.0968ZM16 8C20.4194 8 24 11.5806 24 16C24 20.4194 20.4194 24 16 24C11.5806 24 8 20.4194 8 16C8 11.5806 11.5806 8 16 8ZM21.2258 19.7419C22 18.7097 22.4516 17.4194 22.4516 16C22.4516 12.4516 19.5484 9.54839 16 9.54839C12.4194 9.54839 9.54839 12.4516 9.54839 16C9.54839 17.4194 9.96774 18.7097 10.7419 19.7419C11.5161 18.7419 12.7419 18.0645 14.129 18.0645C14.4516 18.0645 14.9677 18.3871 16 18.3871C17 18.3871 17.5161 18.0645 17.8387 18.0645C19.2258 18.0645 20.4516 18.7419 21.2258 19.7419Z" fill="white"/>
                      </svg>
                  </div>
              </div>
          </div>
          <div className="ai-message-time">{time}</div>
      </div>
      }
    </>
  )
}

interface DialogProps {
    isOpen: boolean;
    onClose: ( isRefetch?:boolean) => void;
    selectedIssue:  any;
  }
const TalkToAiDialog: React.FC<DialogProps> = ({ isOpen, onClose, selectedIssue }) => {
  const classes = useStyles();
  const projectState = useSelector((state: RootState) => state.project);
  const projectType = projectState.projectType;

	const [fullScreenLoading, setFullScreenLoading] = useState(false);

  const [searchQuery, setSearchQuery] = useState<any>(null)

  const formatIframeUrl = () => {
    let issueData = {}
    try {
      if (projectType === "WayMore Project") {
        issueData = {
          issueId: selectedIssue?.id,
          issue: encodeURIComponent(selectedIssue?.issue),
          key: selectedIssue?.key,
          dueDate: selectedIssue?.dueDate,
          status: selectedIssue?.issueData?._links?.status?.title,
          priority: selectedIssue?.issueData?._links?.priority?.title,
          issueType: encodeURIComponent(selectedIssue?.issueType),
          description: encodeURIComponent(selectedIssue?.description),
          assignee: encodeURIComponent(selectedIssue?.issueData?._links?.assignee?.title || 'Unassigned'),
          assigneeEmail: selectedIssue?.issueData?.fields?.assignee?.emailAddress || '',
          createdBy: encodeURIComponent(selectedIssue?.createdBy),
          parentKey: selectedIssue?.issueData?._links?.parent?.href?.split('parents/')?.[1] || '',
          parentId: selectedIssue?.issueData?._links?.parent?.href?.split('parents/')?.[1] || '',
          parentSummery: encodeURIComponent(selectedIssue?.issueData?._links?.parent?.title || ''),
          projectName: encodeURIComponent(selectedIssue?.projectTitle || ''),
          projectId: selectedIssue?.projectLink?.split('projects/')?.[1] || '',
          projectKey: selectedIssue?.projectLink?.split('projects/')?.[1] || ''
        }
      } else {
        issueData = {
          issueId: selectedIssue?.id,
          issue: encodeURIComponent(selectedIssue?.issue),
          key: selectedIssue?.key,
          dueDate: selectedIssue?.dueDate,
          status: selectedIssue?.status,
          priority: selectedIssue?.priority,
          issueType: encodeURIComponent(selectedIssue?.issueType),
          description: encodeURIComponent(selectedIssue?.description),
          assignee: encodeURIComponent(selectedIssue?.issueData?.fields?.assignee?.displayName || 'Unassigned'),
          assigneeEmail: selectedIssue?.issueData?.fields?.assignee?.emailAddress || '',
          createdBy: encodeURIComponent(selectedIssue?.createdBy),
          parentKey: selectedIssue?.issueData?.fields?.parent?.key || '',
          parentId: selectedIssue?.issueData?.fields?.parent?.id || '',
          parentSummery: encodeURIComponent(selectedIssue?.issueData?.fields?.parent?.fields?.summary || ''),
          projectName: encodeURIComponent(selectedIssue?.issueData?.fields?.project?.name || ''),
          projectId: selectedIssue?.issueData?.fields?.project?.id || '',
          projectKey: selectedIssue?.issueData?.fields?.project?.key || ''

        }
      }
    } catch (e) {
      console.log(e, "error")
      issueData = {}
    }
    const issuePayload = {
      id: sessionStorage.getItem('id') || "",
      source: 'manager',
      domain: 'waymore.io',
      manager_type: 'coding_ai',
      ...issueData
    }
    const queryParams = new URLSearchParams(issuePayload).toString();
    setSearchQuery(queryParams)
  }

  useEffect(() => {
    if(selectedIssue) {
      formatIframeUrl();
    }
  }, [selectedIssue])

    return (
      <>
        {/* <Dialog  maxWidth={false} open={isOpen}>
            <DialogTitle>Talk To AI</DialogTitle>
          <div  className='talk-to-ai-dialog-container ' >
            <DialogContent className={classes.talkToAIDialogContent}>
              <div className="expert-modal">
                <ExpertModalContainer onClose={onClose} />
              </div>
              <Backdrop open={fullScreenLoading} sx={{zIndex:(theme)=> theme.zIndex.drawer +1}}>
                <CircularProgress />
              </Backdrop>
            </DialogContent>
          </div>
        </Dialog> */}
        <BootstrapDialog
            aria-labelledby="customized-dialog-title"
            open={isOpen}
        >
          <IconButton
            aria-label="close"
            onClick={() => onClose()}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
          <div className='ai-form-header'>Talk To AI</div>
            <div className='ai-form-container'>
              <div className='ai-form-inner-container'>
                {searchQuery && <iframe
                  title='mini-chatbot-iframe'
                  id="mini-chatbot-iframe"
                  src={`${CHATBOT_URL}?${searchQuery}`}
                  height="550px"
                  width="1100px"
                />}
              </div>
            </div>
          </DialogContent>
        </BootstrapDialog>
      </>
    );
}

export default TalkToAiDialog;


